// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__1UXlm","success":"AnswerItem_success__1K9qv","error":"AnswerItem_error__3acEX"};